import { removeFipIdDots } from './helper.utils';

export const getFipLogoAlt = (fipId, displayName) => {
	const fip = global.objectFormatFip?.[fipId];
	const name = displayName || fip?.fipName || fip?.fipId || fipId;
	return name ? `${name} logo` : 'Financial institution logo';
};

export const getFipDisplayName = (fipId, t, bankObject = null) => {
	const lookupId =
		global.objectFormatFip[fipId]?.fipId ||
		(bankObject?.fipId ? removeFipIdDots(bankObject.fipId) : fipId);
	const translated = t(`fips.${lookupId}`);
	if (translated) {
		return translated;
	}
	return (
		bankObject?.bankName ||
		global.objectFormatFip[fipId]?.fipName ||
		lookupId ||
		fipId
	);
};
